var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1732608945667,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5952,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.68963 222.857882A323.147024 323.147024 0 0 0 133.699696 512.028624c19.268741-87.360934 64.508393-172.720525 134.974272-243.27949C339.326018 198.143627 424.639066 152.950518 512 133.635234a323.472824 323.472824 0 0 0-289.31037 89.176105z",
    fill: "#0052a6",
    "p-id": 5953
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M989.43658 822.143649l-121.709559-121.709559a118.032674 118.032674 0 0 0-92.806448-34.115911 425.168956 425.168956 0 0 0-49.475052-541.758801 424.936242 424.936242 0 0 0-601.007853 0 425.122414 425.122414 0 0 0 0 601.054395c147.401213 147.401213 376.066247 163.83084 541.712259 49.335424a118.218845 118.218845 0 0 0 34.115911 92.806448l121.663016 121.756101c46.077424 45.937795 121.383759 45.937795 167.368097 0a118.498102 118.498102 0 0 0 0.139629-167.368097z m-313.326483-146.004928a354.889249 354.889249 0 0 1-502.011205 0 354.982335 354.982335 0 0 1 0-502.104291 355.028878 355.028878 0 0 1 502.011205 502.104291z",
    fill: "#0052a6",
    "p-id": 5954
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch1);
export default __webpack_public_path__ + "static/media/search_1.3fa43111b0b22fe1023e74b64a76bad1.svg";
export { ForwardRef as ReactComponent };